/**
 * Created by fky on 11/2/2016.
 */
'use strict';
angular.module('betosyswebapp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('betotrack', {
        parent: 'app',
        abstract: true,
        url: '/track',
        ncyBreadcrumb: {
          label: 'Track',
          skip:true
        },
        views: {
          'sidebar@app': {
            template: '<adm-sidebar model="framework.sidebarModel"></adm-sidebar>',
            controller: 'TrackController',
            controllerAs: 'framework'
          }
        }
      })
      .state('betotrack.dashboard', {
        url: '/dashboard',
        ncyBreadcrumb: {
          label: 'Track'
        },
        views: {
          'content@app': {
            templateUrl: 'components/dashboard/trackDashboard.tpl.html',
            controller: 'TrackDashboardCtrl'
          }
        },
        resolve: {
          $title: function () {
            return 'BetoTrack', 'Fleet Management Dashboard';
          },
          $sibebar: ['AdmStatusService', function (AdmStatusService) {
            AdmStatusService.setSidebarVisible(true);
            return true;
          }]
        }
      })
      .state('betotrack.login', {
        url: '/login',
        views: {
          'content@app': {
            templateUrl: 'components/login/login.tpl.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          $title: function () {
            return 'BetoTrack Login';
          },
          $sibebar: ['AdmStatusService', function (AdmStatusService) {
            AdmStatusService.setSidebarVisible(false);
            return false;
          }]
        }
      });

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/track.rout.js